export const getActiveFacets = (facets, activeFacets, widgetId) => {
  let facetList = [];

  facets.forEach(facet => {
    facetList.push({ facet });
  });

  activeFacets?.forEach(item => {
    const facetWithWidgetId = `${item.facet}|${widgetId}`;
    const matchedFacet = facetList.find(
      urlFacet => urlFacet.facet == facetWithWidgetId
    );

    if (!matchedFacet) {
      facetList.push({ facet: facetWithWidgetId });
    }
  });

  facetList = facetList.filter(item => item.facet);

  return facetList;
};
